import { type MutationHookOptions, useMutation } from "@apollo/client";
import { UpdateComplianceRecordMutation } from "../graphql/mutations";
import type {
  UpdateComplianceRecordMutationType,
  UpdateComplianceRecordMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useUpdateComplianceRecordMutation = (
  options?: MutationHookOptions<
    UpdateComplianceRecordMutationType,
    UpdateComplianceRecordMutationVariablesType
  >
) => {
  return useMutation<
    UpdateComplianceRecordMutationType,
    UpdateComplianceRecordMutationVariablesType
  >(UpdateComplianceRecordMutation, options);
};
